import {Action, Attributes, AttributesRow, Card, openDialog} from 'platform/components';

import {isNil, isNotNil} from 'ramda';

import {UtmParameters} from '@dms/api/shared';
import i18n from '@dms/i18n';

import {RequiredTestIdProps, buildArray, suffixTestId} from 'shared/web';

import {UtmForm} from './components/UtmForm';

export interface UtmCardProps extends RequiredTestIdProps {
  parameters: UtmParameters;
  /** Omit to render the card read-only - without the edit action. */
  onSubmit?: (values: UtmParameters) => Promise<unknown>;
  isDisabled?: boolean;
}

export function UtmCard(props: UtmCardProps) {
  const attributes = buildArray<AttributesRow>()
    .add({
      label: i18n.t('entity.interest.utm.source'),
      value: props.parameters.source,
    })
    .add({
      label: i18n.t('entity.interest.utm.medium'),
      value: props.parameters.medium,
    })
    .add({
      label: i18n.t('entity.interest.utm.campaign'),
      value: props.parameters.campaign,
    })
    .add({
      label: i18n.t('entity.interest.utm.term'),
      value: props.parameters.term,
    })
    .add({
      label: i18n.t('entity.interest.utm.content'),
      value: props.parameters.content,
    });

  const editUtm = () => {
    if (isNil(props.onSubmit)) {
      return;
    }

    openDialog(
      <UtmForm
        data-testid={suffixTestId('form', props)}
        parameters={props.parameters}
        onSubmit={props.onSubmit}
      />,
      {
        title: i18n.t('entity.interest.labels.marketing'),
        withAdditionalFooter: true,
        'data-testid': suffixTestId('dialog', props),
      }
    );
  };

  return (
    <Card
      title={i18n.t('entity.interest.labels.marketing')}
      data-testid={props['data-testid']}
      actions={buildArray<Action>().when(isNotNil(props.onSubmit), {
        variant: 'link',
        type: 'button',
        title: i18n.t('general.actions.edit'),
        leftIcon: 'image/edit',
        onClick: editUtm,
        isDisabled: props.isDisabled,
      })}
    >
      <Attributes rows={attributes} data-testid={props['data-testid']} />
    </Card>
  );
}
